import React from 'react';

import svgIcon from 'components/hoc/svgIcon';

const svg = (
  <svg viewBox="0 0 40 40">
    <g id="Atom-/-Icon-/-General-/-Trash" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M32,12 C32.552,12 33,12.447 33,13 C33,13.553 32.552,14 32,14 L32,14 L29.939,14 L28.998,29.062 C29,31.206 27.206,33 25,33 L25,33 L15,33 C12.794,33 11,31.206 11,29 L11,29 L10.061,14 L8,14 C7.448,14 7,13.553 7,13 C7,12.447 7.448,12 8,12 L8,12 Z M27.936,14 L12.064,14 L12.998,28.938 C13,30.103 13.897,31 15,31 L15,31 L25,31 C26.103,31 27,30.103 27,29 L27,29 L27.936,14 Z M16,16 C16.552,16 17,16.447 17,17 L17,17 L17,28 C17,28.553 16.552,29 16,29 C15.448,29 15,28.553 15,28 L15,28 L15,17 C15,16.447 15.448,16 16,16 Z M20,16 C20.552,16 21,16.447 21,17 L21,17 L21,28 C21,28.553 20.552,29 20,29 C19.448,29 19,28.553 19,28 L19,28 L19,17 C19,16.447 19.448,16 20,16 Z M24,16 C24.552,16 25,16.447 25,17 L25,17 L25,28 C25,28.553 24.552,29 24,29 C23.448,29 23,28.553 23,28 L23,28 L23,17 C23,16.447 23.448,16 24,16 Z M22,7 C23.654,7 25,8.346 25,10 L25,10 L25,11 L23,11 L23,10 C23,9.448 22.551,9 22,9 L22,9 L18,9 C17.449,9 17,9.448 17,10 L17,10 L17,11 L15,11 L15,10 C15,8.346 16.346,7 18,7 L18,7 Z"
        id="Combined-Shape"
        fill="#8D929E"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default svgIcon(svg);
